import React, { FC, ReactNode } from 'react'
import Typograf from 'typograf'

type Props = {
  children?: ReactNode
}

export const Typograph: FC<Props> = ({ children }) => {
  const tp = new Typograf({ locale: ['ru', 'en-US'] })
  const result = tp.execute(children as string)

  return <>{result}</>
}
